import type { OutputQuality } from '../api/intelligence';
import { Link } from 'react-router-dom';

const LABELS: Record<string, string> = {
  grounding_review_not_linked: '원본 대조 기록 미연결',
  grounding_review_rejected: '원본 대조에서 오류 확인',
  grounding_review_invalid: '대조 기록 형식·초안 연결 검증 불가',
  memo_saved_validation_unavailable: '저장 메모의 재검사 자료 미연결',
  grounding_schema: '대조 응답 형식 오류',
  grounding_issue_schema: '대조 오류 항목 형식 오류',
  grounding_verdict_conflict: '대조 판정과 오류 목록 불일치',
  invalid_json: 'JSON 응답 해석 불가',
  trace_persistence_failed: '추론 영수증 저장 실패',
  memo_not_fully_ready: '개인 메모의 근거·필드 확인 필요',
  empty_output: '빈 답변', provider_failed: '공급자 실패', provider_truncated: '출력 길이 종료',
  daily_sections_missing: '필수 섹션 누락', completion_marker_missing: '완료 표식 누락',
  unsupported_forecast_probability: '확률의 표본 근거 없음',
  budget_exhausted_finish_reason_unknown: '출력 예산 소진 · 종료 사유 미기록',
};
export default function OutputQualityNotice({ value, grounding }: { value?: OutputQuality; grounding?: { call_id: string; accepted: boolean; state?: string } }) {
  if (!value) return <p className="muted-note">답변 품질 검사 미연결</p>;
  const names: Record<string, string> = {
    ready: '구조 검사 통과 · 사실·예측 검증과 별개', partial: '미완성·근거 검토 필요',
    unusable: '분석으로 사용 불가', review_required: '완결성·근거 확인 필요',
  };
  return <p className={value.state === 'ready' ? 'muted-note' : 'research-alert'}>
    {names[value.state] ?? value.state}
    {value.grounding_verdict != null && <><br/>대조 판정 · {value.grounding_verdict ? '초안 검토 통과' : '초안 수정 필요'}</>}
    {[...value.issues, ...value.warnings].length > 0 && <><br/>
      {[...value.issues, ...value.warnings].map(x => LABELS[x] ?? x).join(' · ')}</>}
    {grounding && <><br/><Link to={`/management/intelligence?call_id=${encodeURIComponent(grounding.call_id)}`}>원본 대조 기록 · {grounding.accepted ? '검토 통과' : grounding.state === 'invalid' ? '검토 불가' : '오류 확인'} →</Link></>}
  </p>;
}
